import { jsx as a, Fragment as f, jsxs as m } from "react/jsx-runtime";
import { useEffect as l, useRef as p } from "react";
import { M as P } from "../../chunks/index.esm.js";
import { r as u } from "../../chunks/server.browser.js";
const w = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHJ4PSIyNSIgZmlsbD0iIzA2NEUzQiIgLz4KPC9zdmc+";
async function h(o, e) {
  const i = new google.maps.Geocoder();
  return new Promise((r, n) => {
    let t = "";
    i == null || i.geocode({ location: { lat: o, lng: e } }, (s, g) => {
      g === "OK" ? s != null && s[0] ? (t = s[0].formatted_address, r(t)) : (t = "No results found", r(t)) : (t = "Geocoder failed due to: " + g, n(t));
    });
  });
}
function T(o, e) {
  var n, t;
  const i = u(/* @__PURE__ */ a(f, { children: /* @__PURE__ */ m("div", { style: {
    color: "white",
    display: "inline-flex",
    alignItems: "center",
    gap: 5
  }, children: [
    /* @__PURE__ */ a("img", { src: e.icon, alt: e.name, width: 18, height: 18 }),
    /* @__PURE__ */ a("span", { children: e.name })
  ] }) }));
  new google.maps.InfoWindow({
    content: i,
    position: (n = e.geometry) == null ? void 0 : n.location,
    ariaLabel: e.name
  }).open(o), (t = e.geometry) != null && t.viewport && (o.fitBounds(e.geometry.viewport), e.geometry.location && o.setCenter(e.geometry.location));
}
async function y(o, e, i, r) {
  if (!(!o || !e) && (e.setPosition(o.getCenter()), r)) {
    const n = o.getCenter().toJSON(), t = await h(n.lat, n.lng), s = {
      id: i ?? "Custom",
      location: { lat: n.lat, lng: n.lng, address: t },
      label: e.getTitle() ?? ""
    };
    r(s);
  }
}
function x(o, e, i, r) {
  l(() => {
    if (!e)
      return;
    let n;
    return o && (n = new google.maps.Marker({
      position: i,
      map: e,
      draggable: !0,
      icon: {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new google.maps.Size(20, 30),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(10, 30)
      },
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + 1
    }), n.addListener("dragend", () => {
      var s;
      const t = (s = n.getPosition()) == null ? void 0 : s.toJSON();
      t && r(t);
    })), google.maps.event.addListener(e, "dragend", () => {
      const t = e.getCenter();
      n == null || n.setPosition(t), t && r(t.toJSON());
    }), () => {
      n == null || n.setMap(null);
    };
  }, [e, o]);
}
function z(o, e, i) {
  const r = p(void 0);
  return l(() => {
    var n;
    if (!(!e || !o))
      return (n = r.current) == null || n.clearMarkers(), r.current = new P({
        map: e,
        markers: i,
        renderer: M
      }), () => {
        var t;
        (t = r.current) == null || t.clearMarkers();
      };
  }, [o, e, i.length]), r;
}
function N(o, e) {
  l(() => {
    if (o)
      return e.forEach((i) => {
        o.controls[google.maps.ControlPosition.TOP_RIGHT].push(i);
      }), () => {
        o.controls[google.maps.ControlPosition.TOP_RIGHT].clear();
      };
  }, [o, e]);
}
const M = {
  render: function(o) {
    return new google.maps.Marker({
      position: o.position,
      label: {
        text: o.count.toString(),
        color: "white",
        fontSize: "12px",
        fontWeight: "bold"
      },
      icon: {
        url: w,
        scaledSize: new google.maps.Size(50, 50),
        anchor: new google.maps.Point(23, 25),
        origin: new google.maps.Point(0, 0),
        labelOrigin: new google.maps.Point(25, 25)
      },
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + o.count
    });
  }
}, A = (o) => {
  const e = document.createElement("div"), i = u(o);
  e.innerHTML = i;
  const r = e.querySelector("svg");
  if (!r)
    return "";
  const n = new XMLSerializer().serializeToString(r), t = new Blob([n], { type: "image/svg+xml;charset=utf-8" }), s = URL.createObjectURL(t);
  return e.remove(), s;
}, L = (o, e, i) => {
  const r = o.getPosition();
  if (!r || !i.getProjection())
    return [];
  const n = Math.pow(2, i.getZoom() || 0), t = i.getProjection().fromLatLngToPoint(r), s = 30;
  return e.filter((g) => {
    const c = g.getPosition();
    if (!c || g.get("markerId") === o.get("markerId"))
      return !1;
    const d = i.getProjection().fromLatLngToPoint(c);
    return Math.sqrt(
      Math.pow((t.x - d.x) * n, 2) + Math.pow((t.y - d.y) * n, 2)
    ) < s;
  });
};
export {
  M as CustomRenderer,
  A as convertSvgToUrl,
  L as findOverlappingMarkers,
  h as generateAddress,
  y as resetMarkerToCenter,
  T as updateMapWithPlace,
  x as useCenterMarker,
  N as useMapControls,
  z as useMarkerCluster
};
